import http from '@/http'

export function userBill() {
  return http.post('/total/user/bill')
}

export function userLog(type) {
  return http.post('/total/user/log', { type })
}

export function ticket() {
  return http.post('/total/ticket')
}

export function cexOrder(type) {
  return http.post('/total/cex/order', { type })
}

export function cexOrderPay() {
  return http.get('/total/cex/order/pay')
}

export function cexOrderBreakdown() {
  return http.get('/total/cex/order/breakdown')
}
